module.exports = __webpack_public_path__ + "img/aParty_110923_I.8ec1c199.jpg";